// JS for Posts Block - Load More, Videos carousel, video popup
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
  // Load More
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.posts-load-more');
    if (!btn) return;
    if (btn.hasAttribute('data-loading')) return;

    const blockId = btn.getAttribute('data-block-id');
    const postsBlock = document.getElementById(blockId);
    if (!postsBlock) return;

    const view = btn.getAttribute('data-view');
    const isCategoriesView = view === 'categories';
    const perPage = parseInt(btn.getAttribute('data-per-page'), 10);
    const total = parseInt(btn.getAttribute('data-total'), 10);
    const categoryIds = btn.getAttribute('data-category-ids') || '';

    btn.setAttribute('data-loading', '');
    btn.style.opacity = '0.5';
    btn.disabled = true;

    const formData = new FormData();
    formData.append('action', 'load_more_posts');
    formData.append('posts_view', view);
    formData.append('per_page', perPage);
    formData.append('nonce', ajax_object.nonce);
    if (categoryIds) {
      formData.append('category_ids', categoryIds);
    }

    if (isCategoriesView) {
      const postsPerCategory = btn.getAttribute('data-posts-per-category') || '';
      const categoriesLoaded = parseInt(btn.getAttribute('data-categories-loaded'), 10);
      formData.append('posts_per_category', postsPerCategory);
      formData.append('categories_loaded', categoriesLoaded);
    } else {
      const offset = parseInt(btn.getAttribute('data-offset'), 10);
      const loaded = parseInt(btn.getAttribute('data-loaded'), 10);
      const firstPostId = btn.getAttribute('data-first-post-id') || '';
      formData.append('offset', offset);
      formData.append('loaded', loaded);
      if (firstPostId) {
        formData.append('first_post_id', firstPostId);
      }
    }

    fetch(ajax_object.ajax_url, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success && result.data.html) {
          const postsContent = postsBlock.querySelector('.posts-content');
          if (isCategoriesView) {
            postsContent.insertAdjacentHTML('beforeend', result.data.html);
          } else {
            const ul = postsContent.querySelector('ul');
            if (ul) {
              ul.insertAdjacentHTML('beforeend', result.data.html);
            }
          }

          const newLoaded = result.data.new_total_loaded;
          btn.setAttribute('data-loaded', newLoaded);
          if (isCategoriesView) {
            btn.setAttribute('data-categories-loaded', result.data.new_categories_loaded);
          }

          if (newLoaded >= total) {
            btn.closest('.posts-read-more').remove();
          } else {
            btn.removeAttribute('data-loading');
            btn.style.opacity = '1';
            btn.disabled = false;
          }
        } else {
          btn.removeAttribute('data-loading');
          btn.style.opacity = '1';
          btn.disabled = false;
        }
      })
      .catch((error) => {
        console.error('Error loading more posts:', error);
        btn.removeAttribute('data-loading');
        btn.style.opacity = '1';
        btn.disabled = false;
      });
  });

  // Videos carousel
  document.querySelectorAll('.posts-videos').forEach(function (wrapper) {
    const swiperEl = wrapper.querySelector('.posts-videos__swiper');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      modules: [Navigation],
      slidesPerView: 1.15,
      spaceBetween: 16,
      navigation: {
        nextEl: wrapper.querySelector('.posts-videos__arrow--next'),
        prevEl: wrapper.querySelector('.posts-videos__arrow--prev'),
      },
      breakpoints: {
        576: { slidesPerView: 2.2, spaceBetween: 20 },
        992: { slidesPerView: 3.2, spaceBetween: 20 },
        1280: { slidesPerView: 4, spaceBetween: 20 },
      },
    });
  });

  // Video popup - move to <body> so its fixed overlay is never affected by an
  // ancestor's stacking context/overflow (matches how the mobile sidebar panel
  // is loaded directly onto <body> elsewhere on this site).
  document.querySelectorAll('.video-popup').forEach(function (popup) {
    document.body.appendChild(popup);
  });

  function openVideoPopup(popupId, videoSrc) {
    const popup = document.getElementById(popupId);
    if (!popup || !videoSrc) return;

    const video = popup.querySelector('.video-popup__video');
    video.src = videoSrc;
    popup.classList.add('active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('video-popup-open');
    video.play().catch(function () {});
  }

  function closeVideoPopup(popup) {
    const video = popup.querySelector('.video-popup__video');
    popup.classList.remove('active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('video-popup-open');
    video.pause();
    video.removeAttribute('src');
    video.load();
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-video-src]');
    if (trigger) {
      openVideoPopup(trigger.getAttribute('data-popup'), trigger.getAttribute('data-video-src'));
      return;
    }

    const closeTrigger = e.target.closest('[data-video-popup-close]');
    if (closeTrigger) {
      const popup = closeTrigger.closest('.video-popup');
      if (popup) closeVideoPopup(popup);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const openPopup = document.querySelector('.video-popup.active');
    if (openPopup) closeVideoPopup(openPopup);
  });
});
